import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MessagesSquare } from 'lucide-react';
import { NewBadge } from '../NewBadge';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const MessagesNavButton = ({ onClick }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const load = () => axios.get(`${BACKEND}/api/messages/unread-count`, { headers: { Authorization: `Bearer ${localStorage.getItem('dentalToken')}` } })
      .then((r) => setCount(r.data.count || 0)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  return (
    <button onClick={onClick} className="w-full flex items-center p-4 hover:bg-sky-50 rounded-md text-left text-lg text-gray-700" data-testid="dashboard-messages-link">
      <MessagesSquare className="h-7 w-7 mr-4 text-sky-600" />
      Messages <NewBadge className="ml-2" testId="messages-new-badge" />
      {count > 0 && <span className="ml-auto text-xs font-bold bg-rose-600 text-white rounded-full px-2 py-0.5" data-testid="messages-unread-badge">{count}</span>}
    </button>
  );
};

export default MessagesNavButton;
